(function($, Drupal, once, drupalSettings, window, document, undefined) {
  'use strict';
  Drupal.behaviors.menu_offcanvas = {
    attach: function (context) {

      if ($("body").hasClass("election-orange") || $("body").hasClass("election-green") || $("body").hasClass("election-blue") || $("body").hasClass("election-purple")) {
      } else {
        $("body").addClass("election-yellow");
      }

      $(once('.election-body', 'body', context)).each(function () {
        
        $(window).on("load", function() {  
          //console.log('window load');  
          GetDaysCount();
   
        });        
        
        console.log('body load');          

        $("#elvoterIframe").on("load", function() {
          $('#spinnerLoader').hide();
        });
        
        if ($("#elvoterIframe").length){  
          var iframes = iFrameResize();
        }

        if( $('#el_piechart').length ) {  
          google.charts.load('current', {'packages':['corechart']});
          google.charts.setOnLoadCallback(drawChart);
        }

        if ($("#autorefresh_election").length){ 
          setTimeout(function () {
              //console.log('Reloading Page');
              location.reload(true);
            }, 5*60000);
        }  

        $('a.link-folder').click(function(e) {
          e.preventDefault();
          e.stopPropagation();
          $(this).parent('.wrapper')
            .toggleClass('is-opened');
        });
  
        $(".covidlink").unbind().click(function(e) {
          e.preventDefault();
          e.stopPropagation();
          $(this).parent('.container')
            .toggleClass('is-opened');
          $('.moretext').slideToggle(); 
        });   

     });

     function drawChart() {
      
      //console.log('drawChart : pie chart load');
      //console.log(drupalSettings.electiondata.title);      
      /*
      var data = google.visualization.arrayToDataTable([
        ['Candidate', 'Total Ballots'],
        ['Work',     11],
        ['Eat',      2]        
      ]);
      */

     var chdata = drupalSettings.electiondata.chartdata;

     //console.log(chdata);

     var election_keyid = drupalSettings.electiondata.keyid;

     var data = google.visualization.arrayToDataTable(chdata);

        if (election_keyid == "elc1" || election_keyid == "elc2" ){
            
            var options = {
              title: drupalSettings.electiondata.title,
              is3D: true,
              legend: 'none',
              colors: ['#FFD64A','#C52127','#000000','#505050','#929090','#D7D7D7','#F5F5F5','#FFE8CC','#FAA946','#DB6727']          
            };

        } else if (election_keyid == "elc3" || election_keyid == "elc4" || election_keyid == "elc5" || election_keyid == "elc6" || election_keyid == "elc7" ){
            
            var options = {
              title: drupalSettings.electiondata.title,
              is3D: true,
              legend: 'none',
              colors: ['#22325B','#657DBD','#7294ea','#929090','#505050','#000000','#C52127','#FFD64A']          
            };

        } else if (election_keyid == "elc8" || election_keyid == "elc9" || election_keyid == "elc10" ){
            
          var options = {
            title: drupalSettings.electiondata.title,
            is3D: true,
            legend: 'none',
            colors: ['#A184BD','#3B314B','#7b65a0','#929090','#505050','#000000','#C52127','#FFD64A','#7b63a3','#968e8e','#939393']          
          };

        } else {
            
          var options = {
            title: drupalSettings.electiondata.title,
            is3D: true,
            legend: 'none',
            colors: ['#30302e','#434341','#565654','#686867','#7b7b7a','#8e8e8d','#a1a1a0','#c7c7c6','#d9d9d9','#ececec']          
          };

        }    
        
        //console.log('results');

      var chart = new google.visualization.PieChart(document.getElementById('el_piechart'));

      chart.draw(data, options);
    }

     function GetDaysCount_old(){
            dateFuture = new Date('2023-10-09');
            dateFuture.setHours(2,0,0,0);

            console.log("Election day : "+dateFuture);

            dateNow = new Date();
            dateNow.setHours(0,0,0,0);

            console.log("Current day : "+dateNow);

            //grab current date
            amount = dateFuture.getTime() - dateNow.getTime();                
            
            // time is already past
            if(amount < 0){              
              
              $("#elcountbox_en").html('Election Day');
              $("#elcountbox_iu").html('ᓂᕈᐊᕐᖕᓇᐅᑉ ᐅᑉᓗᖓᓂᑦᓂᕈᐊᕐᖕᓂᕐᒃ');
              $("#elcountbox_fr").html('Le jour du scrutiny');
              $("#elcountbox_in").html('Vutirviup Upluanit Vutirniq');

            }
            // date is still good
            else{
                
                    days=0;hours=0;mins=0;secs=0;out="";

                    amount = Math.floor(amount/1000);//kill the "milliseconds" so just secs

                    days=Math.floor(amount/86400);//days
                    amount=amount%86400;

                    //console.log('Days :'+days);
                    //console.log('Time :'+amount);
                    
                    /*
                    hours=Math.floor(amount/3600);//hours
                    amount=amount%3600;

                    mins=Math.floor(amount/60);//minutes
                    amount=amount%60;

                    secs=Math.floor(amount);//seconds
                    
                    if(days != 0){out += days +" day"+((days!=1)?"s":"")+",<br />";}
                    if(days != 0 || hours != 0){out += hours +" hour"+((hours!=1)?"s":"")+",<br />";}
                    if(days != 0 || hours != 0 || mins != 0){out += mins +" minute"+((mins!=1)?"s":"")+",<br />";}
                    out += secs +" seconds";
                    */
                   numdays_en = '';
                   numdays_iu = '';
                   numdays_fr = '';
                   numdays_in = '';
                   
                    if(days != 0){
                      numdays_en = days +" day"+((days!=1)?"s":"")
                      numdays_iu = days +" ᐅᑉᓗᐃᑦ"+((days!=1)?"":"")
                      numdays_fr = days +" jour"+((days!=1)?"s":"")
                      numdays_in = days +" ubluit"+((days!=1)?"":"")
                    } else {
                      numdays_en = "1 day";
                      numdays_iu = "1 ᐅᑉᓗᐃᑦ";
                      numdays_fr = "1 jour";
                      numdays_in = "1 ubluit";
                    }

                    //console.log('Time Remaining : '+out);                   
                    $("#elcountbox_en").html('Election Countdown: <strong>'+numdays_en+'</strong>');
                    $("#elcountbox_iu").html('ᓂᕈᐊᕐᓇᐅᑉ ᐅᑉᓗᖓᓄᙵᐅᕙᓪᓕᐊᓂᖅ: <strong>'+numdays_iu+'</strong>');
                    $("#elcountbox_fr").html('Décompte avant l’élection : <strong>'+numdays_fr+'</strong>');
                    $("#elcountbox_in").html('Niruarnamut tikippalliayut: <strong>'+numdays_in+'</strong>');

                    //setTimeout("GetCount()", 1000);
            }
      }

      function GetDaysCount(){
        var election_countdown = drupalSettings.election_countdown;

        //console.log(election_countdown);

        var election_countdown_text = election_countdown.countdown_text;

        $("#elcountbox_en").html(election_countdown_text);
        $("#elcountbox_iu").html(election_countdown_text);
        $("#elcountbox_fr").html(election_countdown_text);
        $("#elcountbox_in").html(election_countdown_text);
        
      }

     

       
      
      var owl = $('.hero_slider');
      owl.owlCarousel({
        margin:0,
        loop: true,
        dots: true,
        nav: false,
        autoplay:true,
        autoplayTimeout: 8000,
        autoplayHoverPause:true,
        smartSpeed: 1800,
        items:1       
      })

    }
  }

})(jQuery, Drupal, once, drupalSettings, this, this.document)
